import { FC } from "react";
import "./Styles.css";

interface FooterProps {
  homePageData?: any;
}

const footerQuickLinks = [
  {
    href: "/giving",
    label: "Giving",
    tone: "border-tcc-green/30 bg-tcc-green/10 text-tcc-green hover:bg-tcc-green/20",
  },
  {
    href: "/support",
    label: "App Support",
    tone: "border-tcc-blue/30 bg-tcc-blue/10 text-[#8ec9f1] hover:bg-tcc-blue/20",
  },
  {
    href: "/privacy",
    label: "Privacy Policy",
    tone: "border-white/15 bg-white/5 text-slate-200 hover:bg-white/10",
  },
  {
    href: "/copyright",
    label: "Copyright",
    tone: "border-tcc-brown/30 bg-tcc-brown/10 text-[#d4c0ac] hover:bg-tcc-brown/20",
  },
];

const Footer: FC<FooterProps> = ({ homePageData }) => {
  const handleSocialClick = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <footer className="footer">
      <div className="footer_container">
        <div className="footer_section">
          <h3 className="footer_title">Contact Us</h3>
          <p className="footer_text">Trinity Christian Church</p>
          <p className="footer_text">
            {homePageData?.address || "123 Church Street"}
          </p>
          <p className="footer_text">
            {homePageData?.phone || "(555) 123-4567"}
          </p>
        </div>

        <div className="footer_section">
          <h3 className="footer_title">Service Times</h3>
          <p className="footer_text">Sunday Worship: 11:00 AM</p>
        </div>

        <div className="footer_section">
          <h3 className="footer_title">Legal</h3>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {footerQuickLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`rounded-2xl border px-4 py-3 text-sm font-semibold tracking-[0.08em] transition ${link.tone}`}
              >
                {link.label}
              </a>
            ))}
          </div>
          <p className="footer_text max-w-sm">
            Public help and legal information for the website and mobile app.
          </p>
        </div>

        <div className="footer_section">
          <h3 className="footer_title">Connect With Us</h3>
          <div className="footer_social">
            {/* <button
              onClick={() =>
                handleSocialClick(
                  homePageData?.instagram || "https://www.instagram.com"
                )
              }
              className="instaBtn"
            >
              <span className="svgContainer">
                <svg
                  fill="white"
                  className="svgIcon"
                  viewBox="0 0 448 512"
                  height="1.5em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
                </svg>
              </span>
              <span className="BG"></span>
            </button> */}

            <button
              onClick={() =>
                handleSocialClick(
                  homePageData?.facebook || "https://www.facebook.com"
                )
              }
              className="faceBtn"
            >
              <span className="faceContainer">
                <svg
                  viewBox="0 0 320 512"
                  height="1.3em"
                  xmlns="http://www.w3.org/2000/svg"
                  className="svgIcon"
                  fill="white"
                >
                  <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"></path>
                </svg>
              </span>
              <span className="faceBG"></span>
            </button>

            {/* <button
              onClick={() =>
                handleSocialClick(
                  homePageData?.youtube || "https://www.youtube.com"
                )
              }
              className="youtubeBtn"
            >
              <span className="youtubeContainer">
                <svg
                  viewBox="0 0 576 512"
                  height="1.3em"
                  xmlns="http://www.w3.org/2000/svg"
                  className="svgIcon"
                  fill="white"
                >
                  <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path>
                </svg>
              </span>
              <span className="youtubeBG"></span>
            </button> */}
          </div>
        </div>
      </div>

      <div className="footer_copyright">
        <p>© {new Date().getFullYear()} Trinity Christian Church. All rights reserved.</p>
        <p className="footer_powered_by">
          Website powered by:{" "}
          <a
            href="https://www.cmjsoftware.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer_powered_by_link"
          >
            CMJ Software
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
